import React from 'react';
import { Check, X } from 'lucide-react';
export function EaseSection() {
  const noNecesitas = ['Pesar tu comida obsesivamente', 'Contar calorías o macros', 'Comprar ingredientes raros o caros', 'Pasar horas cocinando cada día', 'Dejar de comer carbohidratos'];
  const obtienes = ['Plan estructurado día por día', 'Recetas simples de 15 a 20 minutos', 'Ingredientes de tu supermercado local', 'Resultados visibles desde la semana 1', 'Libertad para disfrutar comidas sociales', 'La confianza de saber exactamente qué comer, cuándo y por qué'];
  return <section className="py-5 bg-white" data-id="element-126">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-127">
        <div className="max-w-5xl mx-auto" data-id="element-128">
          <div className="text-center mb-8" data-id="element-129">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-black mb-4" data-id="element-130">
              "Pero yo no tengo tiempo, dinero ni energía para otra dieta
              complicada."
            </h2>
            <p className="text-lg text-sage/80 max-w-2xl mx-auto font-semibold" data-id="element-131">
              Exactamente por eso lo diseñamos así:
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-132">
            {/* Lo que NO necesitás */}
            <div className="bg-cream rounded-3xl p-8 md:p-10 border border-red-100 shadow-sm" data-id="element-133">
              <h3 className="text-2xl font-serif font-bold text-sage mb-8 text-center" data-id="element-134">
                Lo que NO necesitás
              </h3>
              <ul className="space-y-6" data-id="element-135">
                {noNecesitas.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-136">
                    <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-137">
                      <X className="w-5 h-5 text-red-600" data-id="element-138" />
                    </div>
                    <span className="text-sage/80 font-medium" data-id="element-139">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Lo que obtenés */}
            <div className="bg-sage text-cream rounded-3xl p-8 md:p-10 shadow-xl relative overflow-hidden" data-id="element-140">
              <div className="absolute top-0 right-0 w-64 h-64 bg-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-141"></div>

              <h3 className="text-2xl font-serif font-bold text-white mb-8 text-center relative z-10" data-id="element-142">
                Lo que obtenés
              </h3>
              <ul className="space-y-6 relative z-10" data-id="element-143">
                {obtienes.map((item, idx) => <li key={idx} className="flex items-center gap-4" data-id="element-144">
                    <div className="bg-gold p-2 rounded-full flex-shrink-0" data-id="element-145">
                      <Check className="w-5 h-5 text-white" data-id="element-146" />
                    </div>
                    <span className="text-cream font-medium" data-id="element-147">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="text-center bg-mint/40 rounded-2xl p-8 border border-emerald-200 max-w-3xl mx-auto" data-id="element-148">
            <p className="text-xl md:text-2xl font-serif font-bold text-black" data-id="element-149">
              Empezá hoy mismo con 2 ingredientes que ya tenés en tu cocina:{' '}
              <span className="text-gold" data-id="element-150">Jengibre y Manzanilla</span>
            </p>
            <p className="text-sage/80 mt-2" data-id="element-151">
              Son los primeros activadores del CMM que vas a usar en el Día 1
              del Protocolo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}